<script>
import Filler from './../Filler.vue';
import {createPoster, fetchPoster, updatePoster} from '../services/poster_service';

export default {
  extends: Filler,

  data() {
    return {
      templateSelected: undefined,
      productByMagazine: null,
      maxPrice: null,
      minPrice: null,
    }
  },

  watch: {
    productSelected() {
      this.getProductRangeByCode();
    },

    valueCash() {
      let validateField = (this.valueCash && this.valueToDouble(this.valueCash) !== 0)
          && this.maxPrice
          && this.minPrice
          && !this.isValidPriceMargin(this.valueCash, 'value_cash');

      if (validateField) {
        let message = `Preço fora da margem de valores! Preço min: ${this.doubleToValue(this.minPrice)} | Preço max: ${this.doubleToValue(this.maxPrice)}`;
        this.$root.$emit('error-form', {field: 'value_cash', message: message});
      } else {
        this.$root.$emit('error-form-clean', {field: 'value_cash'});
      }
    },

    valueOld() {
      let validateField = (this.valueOld && this.valueToDouble(this.valueOld) !== 0)
          && this.maxPrice
          && this.minPrice
          && !this.isValidPriceMargin(this.valueOld, 'value_old');

      if (validateField) {
        let message = `Preço Promocional fora da margem de valores! Preço min: ${this.doubleToValue(this.minPrice)} | Preço max: ${this.doubleToValue(this.maxPrice)}`;
        this.$root.$emit('error-form', {field: 'value_old', message: message});
      } else {
        this.$root.$emit('error-form-clean', {field: 'value_old'});
      }
    },

    valueCashTag() {
      let validateField = (this.valueCashTag && this.valueToDouble(this.valueCashTag) !== 0)
          && this.maxPrice
          && this.minPrice
          && !this.isValidPriceMargin(this.valueCashTag, 'value_cash_tag');

      if (validateField) {
        let message = `Preço fora da margem de valores! Preço min: ${this.doubleToValue(this.minPrice)} | Preço max: ${this.doubleToValue(this.maxPrice)}`;
        this.$root.$emit('error-form', {field: 'value_cash_tag', message: message});
      } else {
        this.$root.$emit('error-form-clean', {field: 'value_cash_tag'});
      }
    }
  },

  computed: {
    hasWithoutPaymentInitial: {
      get() {
        return this.$store.getters['poster/field']('has_without_payment_initial');
      },
      set(value) {
        this.$store.commit('poster/SET_HAS_WITHOUT_PAYMENT_INITIAL', value);
      },
    },
    valueCashTag() {
      return this.$store.state.poster.fields.value_cash_tag;
    },
    valueCash() {
      return this.$store.state.poster.fields.value_cash;
    },
    valueOld() {
      return this.$store.state.poster.fields.value_old;
    },
    posterContent: {
      get() {
        if (typeof this.template != 'undefined') {
          return this.template.content;
        }
        if (typeof this.posterState != 'undefined') {
          return this.$store.getters['poster/field']('content');
        }
      },
    },

    template() {
      return this.$store.state.selector.template;
    },

    campaign() {
      if (this.template && this.campaigns) {
        return this.campaigns.find((campaign) => campaign.id === this.template.campaign_id);
      }
    },

    campaigns() {
      return this.$store.state.selector.available_campaigns;
    },
  },

  mounted() {
    this.$root.$on('template-selected', (payload) => this.templateSelected = payload);
  },

  methods: {
    isValidPriceMargin(value, field) {
      if (!!this.posterFields && this.posterFields.indexOf(field) == -1) {
        return true;
      }

      let formatsMinAndMaxPrice = [
          'UPSELLP',
          'UPSELLS',
      ]

      if (this.template && formatsMinAndMaxPrice.includes(this.template.format_name)) {
        let price = this.valueToDouble(value);
        return price >= this.minPrice && price <= this.maxPrice;
      }

      return true;
    },

    inTemplate(dataRole) {
      return (this.posterContent && _.includes(this.posterContent, dataRole));
    },

    validateParceledWithoutInterest() {
      if (!!this.posterFields && this.posterFields.indexOf('value_plot') == -1) {
        return true;
      }

      if (this.campaign && this.campaign.name.toLowerCase() != 'parcelado sem juros') {
        return true;
      }

      const product = this.$store.getters['poster/getSelectedProduct'];

      if (!!product) {
        const valueOld = this.valueToDouble(this.$store.state.poster.fields.value_old);
        const valueCash = this.valueToDouble(this.$store.state.poster.fields.value_cash);
        const productPrice = parseFloat(product.price.replace(/\./g, "").replace(/,/g, "."));
        const percentage = parseFloat((productPrice * 10) / 100);

        if (!valueOld) {
          return true;
        }

        return (productPrice + percentage) >= valueOld
            && valueOld >= (productPrice - percentage)
            && (productPrice + percentage) >= valueCash
            && valueCash >= (productPrice - percentage);
      }
    },

    validateTotalTerm() {
      if (!!this.hasWithoutPaymentInitial) {
        return true;
      }

      if (!!this.posterFields && this.posterFields.indexOf('total_term') == -1) {
        return true;
      }
      if (!!this.posterFields && this.posterFields.indexOf('value_cash') == -1) {
        return true;
      }
      let totalTerm = this.$store.state.poster.fields.total_term;
      let valueOld = this.$store.state.poster.fields.value_old;
      let valueCash = this.$store.state.poster.fields.value_cash;
      let reducedValue = this.$store.state.poster.fields.reduced_value;

      valueCash = this.valueToDouble(valueCash);
      valueOld = this.valueToDouble(valueOld);
      reducedValue = this.valueToDouble(reducedValue);
      totalTerm = this.valueToDouble(totalTerm);

      if (reducedValue > 0 && this.inTemplate('reduced_value')) {
        return reducedValue <= totalTerm;
      } else if (valueOld > 0 && this.inTemplate('value_old')) {
        return valueOld <= totalTerm;
      } else {
        return valueCash <= totalTerm;
      }
    },

    validatePrice() {
      // if (!this.inArray('product_code'))
      //   return true;
      // let oldPrice = this.productSelected.old_price;
      // oldPrice = this.valueToDouble(oldPrice);
      // let price = 0;
      // if (!!this.posterFields && this.posterFields.indexOf('value_old') !== -1) {
      //   price = this.productSelected.value_old;
      // } else {
      //   price = this.productSelected.price;
      // }
      // price = this.valueToDouble(price);
      // const maxPrice = oldPrice + oldPrice / 100 * 2;
      // const minorPrice = oldPrice - oldPrice / 100 * 20;

      // return minorPrice <= price && price <= maxPrice;
      return true;
    },

    validateInterestFields() {
      if (!this.isHybrid) {
        return true;
      }

      if (!this.posterFields) {
        return false;
      }

      let hasCetPy = this.posterFields.indexOf('cet_py') != -1;
      let hasInterest = this.posterFields.indexOf('has_interest') != -1;

      if (!hasInterest && !hasCetPy) {
        return true;
      }

      let cetPyValue = this.valueToDouble(this.$store.getters['poster/field']('cet_py'));
      let interestValue = this.valueToDouble(this.$store.getters['poster/field']('has_interest'));

      return cetPyValue != 0 && interestValue != 0;
    },

    validateValuePlot() {
      if (!!this.posterFields && this.posterFields.indexOf('value_plot_interest') !== -1) {
        return this.valueToDouble(this.$store.getters['poster/field']('value_plot_interest')) != 0;
      }

      if (!!this.posterFields && this.posterFields.indexOf('value_plot') !== -1) {
        return this.valueToDouble(this.$store.getters['poster/field']('value_plot')) != 0;
      }

      if (!!this.posterFields && this.posterFields.indexOf('value_plot_separated') !== -1) {
        return this.valueToDouble(this.$store.getters['poster/field']('value_plot_separated')) != 0;
      }

      return true;
    },

    submitPoster() {
      this.inputs = !!this.inputs;
      if (this.needValidate() && (this.validDatesInArray() && (this.emptyValidDates() || this.invalidDates()))) {
        this.throwPopUp("Datas 'Valido de' e 'Válido até' inválidas!", 50);
      } else if (!this.validateSelects()) {
        this.throwPopUp("Selecione todos os campos do modelo do cartaz para salvar!", 50);
      } else if (!this.validOldAndCashValues()) {
        this.$root.$emit('error-form', {
          field: 'value_old',
          message: "'Preço Promocional' deve ser menor ou igual a 'Valor'"
        });
        this.$root.throwFlashMessage('warning', 'Verifique os campos incorretos');
      } else if (!this.validateTotalTerm()) {
        this.$root.$emit('error-form', {
          field: 'total_term',
          message: "'Total a prazo' deve ser maior ou igual a 'preço'"
        });
        this.$root.throwFlashMessage('warning', 'Verifique os campos incorretos');
      } else if (!this.validateProduct()) {
        this.$root.$emit('has-product-error', {hasError: true, message: "Você deve selecionar um produto"});
        this.$root.throwFlashMessage('warning', 'Verifique os campos obrigatórios');
      } else if (!this.validatePrice() && !this.isHybrid) {
        this.throwPopUp("Valor fora da margem entre 2% acima e 20% abaixo do valor inicial!", 50);
      } else if (!this.isValidPriceMargin(this.valueCash, 'value_cash')) {
        let message = `Preço fora da margem de valores! Preço min: ${this.doubleToValue(this.minPrice)} | Preço max: ${this.doubleToValue(this.maxPrice)}`;
        this.$root.$emit('error-form', {field: 'value_cash', message: message});
        this.$root.throwFlashMessage('warning', 'Verifique os erros nos campos');
      } else if (!this.isValidPriceMargin(this.valueOld, 'value_old')) {
        let message = `Preço Promocional fora da margem de valores! Preço min: ${this.doubleToValue(this.minPrice)} | Preço max: ${this.doubleToValue(this.maxPrice)}`;
        this.$root.$emit('error-form', {field: 'value_old', message: message});
        this.$root.throwFlashMessage('warning', 'Verifique os erros nos campos!');
      } else if (!this.isValidPriceMargin(this.valueCashTag, 'value_cash_tag')) {
        let message = `Preço Etiqueta fora da margem de valores! Preço min: ${this.doubleToValue(this.minPrice)} | Preço max: ${this.doubleToValue(this.maxPrice)}`;
        this.$root.$emit('error-form', {field: 'value_cash_tag', message: message});
        this.$root.throwFlashMessage('warning', 'Verifique os erros nos campos!');
      } else if (!this.validateInterestFields()) {
        this.$root.$emit('error-form', {field: 'has_interest', message: "Insira as taxas de juros!"});
        this.$root.throwFlashMessage('warning', 'Verifique os campos obrigatórios');
      } else if (!this.validatePaymentType()) {
        this.$root.$emit('error-form', {field: 'payment_type', message: "Selecione a Forma de Pagamento!"});
        this.$root.throwFlashMessage('warning', 'Verifique os campos obrigatórios');
      } else if (!this.validateValuePlot()) {
        this.throwPopUp("O valor da parcela deve ser acima de R$ 0,00!", 50);
      } else if (!this.validateParceledWithoutInterest()) {
        this.throwPopUp("O valor a prazo não coincide com o cálculo", 50);
      } else if (this.action == 'create') {
        const vm = this;
        this.poster = $('#preview').html();

        let data = this.$store.getters['getFormFields'];

        if (this.templateSelected) {
          data.template_id = this.templateSelected.id;
        }

        createPoster(data).then((response) => {
          this.$root.throwFlashMessage('success', response.message);
          if (!this.isAllowPosterCreation) {
            this.$store.commit('SET_ACTION', 'update');
            this.$store.commit('SET_POSTER_ID', response.data.id);

            let id = response.data.id;
            this.$root.$emit('releasePrintOrDownloadPoster', {
              posterId: id,
              paperFormatId: $('#selectFormat').find(':selected').val(),
            });

            this.$root.$emit('has-product-error', {hasError: false, message: null});
          } else {
            vm.postersSelected.push(response.data.id);
            this.$store.commit('releasePosters/SET_POSTER_ID', undefined);
          }
        }).catch((error) => {
          this.$root.throwFlashMessage('danger', error.message);
        });
      } else if (this.action == 'update') {
        this.poster = $('#preview').html();
        this.saved = true;

        let data = this.$store.getters['getFormFields'];

        if (this.templateSelected) {
          data.template_id = this.templateSelected.id;
        }

        updatePoster(this.$store.state.poster.id, data).then((response) => {
          this.$root.throwFlashMessage('success', response.message);
        }).catch((error) => {
          this.$root.throwFlashMessage('danger', error.message);
        });
      }
    },

    fetchPosterToEdit(event) {
      if (this.posterId) {
        fetchPoster(this.posterId).then((poster) => {
          poster.fields.image = undefined;
          poster.fields.qrcode = undefined;
          poster.fields.barcode = undefined;
          poster.fields.insert_custom_qrcode = true;
          poster.fields.insert_qrcode = !!_.get(poster, 'fields.qr_code', false);
          poster.fields.insert_barcode = !!_.get(poster, 'fields.bar_code', false);
          let optionalFreeText = _.get(poster, 'fields.optional_free_text');
          optionalFreeText = optionalFreeText == null ? '' : String(optionalFreeText).trim();
          if (optionalFreeText === 'Texto livre opcional') {
            optionalFreeText = '';
          }
          poster.fields.optional_free_text = optionalFreeText;
          poster.fields.insert_optional_free_text = !!optionalFreeText;
          poster.insertExpirationDates = !!_.get(poster, 'fields.valid_from', false);
          poster.insertProductExpirationDates = !!_.get(poster, 'fields.validate', false);
          poster.insertProductOlder = !!_.get(poster, 'fields.product_older', false);
          if (this.valueToDouble(poster.fields.value_old) !== 0) {
            poster.fields.old_price = poster.fields.value_old;
          } else {
            poster.fields.old_price = poster.fields.value_cash;
          }
          poster.insertExpirationDates = poster.fields.valid_from !== null;
          poster.payment_types = [];

          if (poster.fields.parcel != 0) {
            poster.fields.parceled_interest = poster.fields.parcel;
          }

          poster.fields.condition = undefined;
          this.$store.commit('SET_POSTER', poster);
          this.$store.commit('SET_FETCHED_POSTER', poster);
          let theme = this.$store.getters['selector/getThemeById'](poster.theme_id);
          this.alterThemeToEdit(theme);
          this.isPosterLoaded = true;

          this.$root.$emit('releasePrintOrDownloadPoster', {
            posterId: this.posterId,
            paperFormatId: theme.paper_format_id,
          });

        }).catch((error) => {
          this.$root.throwFlashMessage('danger', error.message);
        });
      } else {
        this.isPosterLoaded = true;
      }
    },

    validatePaymentType() {
      if (!this.inArray('payment_type')) {
        return true;
      }

      return !!this.$store.getters['poster/field']('payment_type');
    },

    needValidate() {
      return this.insertExpirationDates;
    },

    getProductRangeByCode() {
      if (!!this.productSelected && !!this.productSelected.integration_code) {
        axios.get(`/ajax/online/get-product-range-prices-by-code-magazine?product_code=${this.productSelected.integration_code}`).then(response => {
          const data = response.data;
          this.maxPrice = _.get(data, 'maxPrice', 0);
          this.minPrice = _.get(data, 'minPrice', 0);
        }).catch(() => {
          return this.$root.throwFlashMessage('error', 'Produto não encontrado!');
        });
      } else {
        this.maxPrice = null;
        this.minPrice = null;
      }
    },
    doubleToValue(value) {
      if (typeof value === 'number') {
        return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      return value;
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/magazineluiza/Filler.vue